import React from "react"

import { contextPlaceholderFunction } from "@/lib/context/placeholderFunction"
import type { Geolocation } from "@/lib/geolocation"
import { defaultDistanceOption } from "@/lib/geolocation/distance/default"
import { distanceOptionToKey } from "@/lib/geolocation/distance/distance"

export const GeolocationContext = React.createContext<Geolocation.ContextData>({
  chooseDistance: contextPlaceholderFunction,
  chooseSuggestion: contextPlaceholderFunction,
  distance: defaultDistanceOption,
  distanceKey: distanceOptionToKey(defaultDistanceOption),
  fetchSuggestions: contextPlaceholderFunction,
  permissionDenied: false,
  processing: undefined,
  reset: contextPlaceholderFunction,
  suggestions: [],
  useMyLocation: contextPlaceholderFunction,
})
